// @ts-nocheck

import type {Contact} from 'src/types/contacts';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import * as React from 'react';
import _get from 'lodash/get';

import {getErrors} from 'src/utils/validation';

import ErrorInput from 'src/components/lib/error-input';
import PhoneInput from 'src/components/lib/phone-input';

import css from './editor.css';


const ContactEditor = ({
  contact,
  errors,
  onChange,
  onSubmit,
  onCancel,
  saveLabel = 'Save',
}: {
  contact: Contact;
  errors: Record<any, any>;
  onChange: (propName: string, value: string) => void;
  onSubmit: (event: React.SyntheticEvent<HTMLFormElement>) => void;
  onCancel: () => void;
  saveLabel?: string;
}) => {
  const {t} = useLabelTranslation();

  let saveLabelTranslate;

  if (saveLabel === 'Save') {
    saveLabelTranslate = t('Save', 'Save');
  }

  return (
    <form className={css.form} onSubmit={onSubmit}>
      <div className={css.row}>
        <Field propName="First Name">
          <ErrorInput
            type="text"
            className={css.input}
            name="firstName"
            value={contact.firstName || ''}
            onChange={({currentTarget: {value}}) =>
              onChange('firstName', value)
            }
            errors={getErrors(errors, 'firstName')}
          />
        </Field>
        <Field propName="Last Name">
          <ErrorInput
            type="text"
            className={css.input}
            name="lastName"
            value={contact.lastName || ''}
            onChange={({currentTarget: {value}}) => onChange('lastName', value)}
            errors={getErrors(errors, 'lastName')}
          />
        </Field>
        <Field propName="phone">
          <PhoneInput
            className={css.input}
            name="phone"
            value={contact.phone}
            onChange={(value) => onChange('phone', value)}
            errors={getErrors(errors, 'phone')}
          />
        </Field>
      </div>
      <div className={css.row}>
        <Field propName="email">
          <ErrorInput
            type="email"
            className={css.input}
            name="email"
            value={contact.email || ''}
            onChange={({currentTarget: {value}}) => onChange('email', value)}
            errors={getErrors(errors, 'email')}
          />
        </Field>
      </div>
      <div className={css.actions}>
        <button className={css.cancel} onClick={onCancel} type="button">{`${t(
          'Cancel',
          'Cancel',
        )}`}</button>
        <button className={css.submit} disabled={Boolean(errors)}>
          {saveLabelTranslate}
        </button>
      </div>
    </form>
  );
};

export default ContactEditor;

const Field = ({
  propName,
  children,
}: {
  propName: string;
  children: React.ReactNode;
}) => {
  const {t} = useLabelTranslation();
  let propTranslate;

  if (propName === 'First Name') {
    propTranslate = t('First_Name', 'First Name');
  } else if (propName === 'Last Name') {
    propTranslate = t('Last_Name', 'Last Name');
  } else if (propName === 'email') {
    propTranslate = t('Email', 'Email');
  } else if (propName === 'phone') {
    propTranslate = t('Phone', 'Phone');
  }

  return (
    <label>
      <span className={css.label}>{propTranslate}</span>
      {children}
    </label>
  );
};
